import * as React from 'react';
import { Button } from 'reactstrap';
import XSVG from 'components/shared/svg/XSVG';
import { FilterButtonProps } from '.';

/**
 * Component for filter item close buttons
 */
export default function FiltersListCloseButton(props: FilterButtonProps) {
	return (
		<Button
			onClick={props.onClick}
			type="button"
			className="filters-list-item__close-btn"
			aria-label={props.ariaLabel}
		>
			<XSVG class="filters-list-item__close-icon" />
		</Button>
	);
}
